import { isCtrlKeyPressed, isMac } from '@react-aria/utils'
import { useIsClient } from '@uidotdev/usehooks'
import { SearchLg } from '#app/components/icons/solid'
import { useEffect, useRef } from 'react'
import { Input } from '#app/components/shared/input/index.tsx'

export const SearchBar = ({
	placeholder,
	query,
	setQuery,
}: {
	placeholder: string
	query: string
	setQuery: (query: string) => void
}) => {
	const inputRef = useRef<HTMLInputElement>(null)

	const isClient = useIsClient()
	useEffect(() => {
		const handleKeyDown = (e: KeyboardEvent) => {
			if (e.key === 'k' && isCtrlKeyPressed(e)) {
				e.preventDefault()
				inputRef.current?.focus()
			}
		}

		document.addEventListener('keydown', handleKeyDown)
		return () => document.removeEventListener('keydown', handleKeyDown)
	}, [])

	const shortcut = isClient ? (isMac() ? '⌘K' : 'Ctrl+K') : undefined

	return (
		<Input
			ref={inputRef}
			size="md"
			shortcut={shortcut}
			icon={SearchLg}
			name="search"
			placeholder={placeholder}
			value={query}
			onChange={setQuery}
		/>
	)
}
